// Events Charity Slider JS
var LP_events_charity_swiper = new Swiper(".LP_events_charity_main_slider", {
  slidesPerView: 2,
  spaceBetween: 58,
  speed: 500,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0:{
      slidesPerView: 1,
      spaceBetween: 58,
    },
    750:{
      slidesPerView: 2,
      spaceBetween: 58,
    }
  }
});

// Events Charity Slider JS
var LP_cards_slider = new Swiper(".LP_text_with_cards_section_cards_slider", {
  slidesPerView: 2,
  spaceBetween: 18,
  speed: 500,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0:{
      slidesPerView: 1,
      spaceBetween: 18,
    },
    750:{
      slidesPerView: 2,
      spaceBetween: 18,
    }
  }
});